import { flattenObjectWithKeyPrefix, precedenceBasisLookup } from '../misc'
import { ALL_AUTH_PARAMS } from '../constants'

export const flattenObjectByPrecedenceForAuthStorage = obj => {
  const keyPrefixedFlattenedObject = flattenObjectWithKeyPrefix(obj)
  let result = {}
  for (const key in ALL_AUTH_PARAMS) {
    const value = precedenceBasisLookup(
      key,
      keyPrefixedFlattenedObject,
      ALL_AUTH_PARAMS[key]?.precedence || []
    )
    if (value !== undefined) {
      result[key] = value
    }
  }
  return result
}
